import { TuosBackground } from '@components/TuosBackground';

export const SiteLoading = () => {
  return (
    <div className="fixed inset-0 w-full h-full flex items-center justify-center overflow-hidden">
      <TuosBackground />
      {/* Green overlay with backdrop blur */}
      <div className="absolute inset-0 bg-primary-100 bg-opacity-75 backdrop-blur-sm z-5"></div>
      <div className="relative z-10 flex flex-col items-center justify-center space-y-6">
        <div className="flex flex-col items-center space-y-4">
          {/* Loading Spinner */}
          <div className="w-16 h-16 border-4 border-green-200 border-t-green-600 rounded-full animate-spin"></div>

          {/* Loading Text */}
          <p className="text-white text-xl font-medium">Loading...</p>
        </div>
      </div>
    </div>
  );
};
